{
  "nameInput": {
    "placeholder": "Siapa nama Anda?"
  },
  "signIn": {
    "tagline": "Mulai dengan niat.",
    "signingIn": "Sedang masuk…",
    "continueApple": "Lanjutkan dengan Apple",
    "continueApple_aria": "Lanjutkan dengan Apple",
    "continueGoogle": "Lanjutkan dengan Google",
    "continueGoogle_aria": "Lanjutkan dengan Google",
    "logo_alt": "Rhemn",
    "footer": "Dengan masuk, Anda menyetujui ketentuan layanan dan <privacyLink>Kebijakan Privasi</privacyLink> kami.",
    "divider": "atau"
  },
  "email": {
    "identity": {
      "label": "Alamat email",
      "placeholder": "you@example.com",
      "change": "Ubah",
      "change_aria": "Ubah alamat email"
    },
    "password": {
      "label": "Kata sandi",
      "labelNew": "Pilih kata sandi",
      "placeholder": "Kata sandi",
      "placeholderNew": "Buat kata sandi",
      "show": "Tampilkan kata sandi",
      "hide": "Sembunyikan kata sandi"
    },
    "actions": {
      "continue": "Lanjutkan",
      "signIn": "Masuk",
      "createAccount": "Buat akun",
      "forgot": "Lupa kata sandi?",
      "backToSignIn": "Kembali ke halaman masuk",
      "iVerified": "Saya sudah memverifikasi email saya",
      "resend": "Kirim ulang tautan",
      "resendIn": "Kirim ulang dalam {{time}}",
      "signInInstead": "Masuk"
    },
    "busy": {
      "checking": "Memeriksa…",
      "signingIn": "Sedang masuk…",
      "creating": "Membuat akun Anda…",
      "sending": "Mengirim…"
    },
    "switch": {
      "toCreate": "Baru di Rhemn? <switchBtn>Buat akun</switchBtn>",
      "toSignIn": "Sudah punya akun? <switchBtn>Masuk</switchBtn>"
    },
    "strength": {
      "tooShort": "Minimal 12 karakter.",
      "level1": "Bagus. Makin panjang makin kuat.",
      "level2": "Kata sandi kuat.",
      "level3": "Kata sandi sangat kuat."
    },
    "sent": {
      "title": "Periksa kotak masuk Anda",
      "body": "Kami mengirim tautan pengaturan ulang ke {{email}}. Tautan berlaku selama satu jam.",
      "resent": "Terkirim lagi. Periksa kotak masuk Anda."
    },
    "verify": {
      "title": "Konfirmasi email Anda",
      "body": "Kami mengirim tautan ke {{email}}. Buka tautan itu untuk menyelesaikan penyiapan akun — selanjutnya kami lanjutkan secara otomatis.",
      "waiting": "Menunggu Anda membuka tautan…",
      "resent": "Terkirim lagi. Periksa kotak masuk Anda."
    },
    "errors": {
      "invalidEmail": "Itu tidak tampak seperti alamat email.",
      "missingPassword": "Masukkan kata sandi Anda.",
      "invalidCredential": "Email atau kata sandi salah.",
      "emailInUse": "Email itu sudah memiliki akun. <signInBtn>Masuk saja.</signInBtn>",
      "weakPassword": "Gunakan minimal 12 karakter.",
      "passwordTooShort": "Gunakan minimal 12 karakter.",
      "passwordCommon": "Kata sandi itu terlalu mudah ditebak. Coba sesuatu yang kurang bisa diprediksi.",
      "emailNotVerified": "Konfirmasi email Anda sebelum melanjutkan.",
      "providerGoogle": "Email ini sudah disiapkan dengan Google. Lanjutkan dengan Google di bawah.",
      "providerApple": "Email ini sudah disiapkan dengan Apple. Lanjutkan dengan Apple di bawah.",
      "userDisabled": "Akun ini telah dinonaktifkan.",
      "requiresRecentLogin": "Masuk lagi untuk melakukan perubahan ini.",
      "sessionExpired": "Sesi Anda telah berakhir. Masuk lagi.",
      "expiredActionCode": "Tautan itu sudah kedaluwarsa. Minta yang baru.",
      "invalidActionCode": "Tautan itu sudah tidak berlaku. Minta yang baru.",
      "tooManyRequests": "Terlalu banyak percobaan. Tunggu beberapa menit, atau atur ulang kata sandi Anda.",
      "network": "Tidak ada koneksi. Periksa jaringan Anda dan coba lagi.",
      "operationNotAllowed": "Masuk dengan email tidak tersedia saat ini.",
      "generic": "Terjadi kesalahan. Silakan coba lagi."
    },
    "a11y": {
      "stepEmail": "Langkah 1 dari 2. Masukkan alamat email Anda.",
      "stepPasswordSignIn": "Langkah 2 dari 2. Masukkan kata sandi Anda untuk masuk.",
      "stepPasswordCreate": "Langkah 2 dari 2. Pilih kata sandi untuk akun baru Anda.",
      "stepSent": "Tautan pengaturan ulang terkirim. Periksa kotak masuk Anda.",
      "stepVerify": "Akun dibuat. Tautan verifikasi terkirim.",
      "resendReady": "Anda dapat mengirim ulang tautan sekarang."
    }
  }
}
